import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dDateTime$dInstant from "../Data.DateTime.Instant/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMaybe$dExtra from "../Data.Maybe.Extra/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dTime$dLocal from "../Data.Time.Local/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as Effect$dNow from "../Effect.Now/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dCalendar$dTypes$dAvailability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dCurrency from "../Restaumatic.I18n.Currency/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dMenu$dV2$dEnv from "../Restaumatic.Menu.V2.Env/index.js";
import * as Restaumatic$dMenu$dV2$dItemVariants from "../Restaumatic.Menu.V2.ItemVariants/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic$dMenu$dV2$dParametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dPriceView from "../Restaumatic.Menu.V2.PriceView/index.js";
import * as Restaumatic$dMenu$dV2$dProductKey from "../Restaumatic.Menu.V2.ProductKey/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dFulfillmentMethod from "../Restaumatic.Menu.V2.Types.FulfillmentMethod/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId from "../Restaumatic.Menu.V2.Types.InternalParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dOrderOrigin from "../Restaumatic.Menu.V2.Types.OrderOrigin/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dPrelude$dSpecularExtra from "../Restaumatic.Prelude.SpecularExtra/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon from "../Restaumatic.Site.Components.Cart.Integration.Common/index.js";
import * as Restaumatic$dSite$dI18n from "../Restaumatic.Site.I18n/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dCallback from "../Specular.Callback/index.js";
import * as Specular$dDom$dBrowser from "../Specular.Dom.Browser/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dWidget from "../Specular.Dom.Widget/index.js";
import * as Specular$dExtra from "../Specular.Extra/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dProfiling from "../Specular.Profiling/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Utils$dDOM from "../Utils.DOM/index.js";
import * as Web$dDOM$dDOMTokenList from "../Web.DOM.DOMTokenList/index.js";
import * as Web$dDOM$dDocument from "../Web.DOM.Document/index.js";
import * as Web$dDOM$dElement from "../Web.DOM.Element/index.js";
import * as Web$dDOM$dHTMLCollection from "../Web.DOM.HTMLCollection/index.js";
import * as Web$dHTML from "../Web.HTML/index.js";
import * as Web$dHTML$dWindow from "../Web.HTML.Window/index.js";
import {initMenuToggle} from "./foreign.js";
const toFulfillmentMethod = v => {
  if (v.tag === "Delivery") { return Restaumatic$dMenu$dV2$dTypes$dFulfillmentMethod.Delivery; }
  if (v.tag === "NoContactDelivery") { return Restaumatic$dMenu$dV2$dTypes$dFulfillmentMethod.Delivery; }
  if (v.tag === "Takeaway") { return Restaumatic$dMenu$dV2$dTypes$dFulfillmentMethod.Takeaway; }
  if (v.tag === "DineIn") { return Restaumatic$dMenu$dV2$dTypes$dFulfillmentMethod.DineIn; }
  $runtime.fail();
};
const showElement = element => {
  const $0 = Web$dDOM$dElement.classList(element);
  return () => {
    const classList = $0();
    return Web$dDOM$dDOMTokenList.remove(classList)("hidden")();
  };
};
const sectionItemButton = locale => sectionParametersD => catalogueMemo => menuSection => menuSectionItem => menuEnv => openProductCreator$p => cartProductCountFn => {
  const openProductCreator = Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.withAvailabilityValidation(catalogueMemo.catalogue)(menuEnv)({
    openProductCreator: openProductCreator$p,
    next: openProductCreator$p
  });
  if (menuSectionItem.tag === "SingleProduct") {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(menuSectionItem._1.itemProduct)(Data$dRecord.unsafeGet("products")(catalogueMemo.catalogue));
    if ($0.tag === "Just") {
      const $1 = $0._1;
      return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("btn-group")])(Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)({
        MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
        MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
      })((() => {
        const $2 = Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dMenu$dV2$dItemVariants.menuItemVariants(locale)(catalogueMemo)(menuSection)(menuSectionItem._1.itemProduct)($1))((() => {
          const $2 = Specular$dFRP$dBase.semigroupDynamic({append: Data$dMap$dInternal.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)}).append((() => {
            const $2 = Restaumatic$dMenu$dV2$dParametric.fromCustomParameterValues(menuSectionItem._1.customParameterValues);
            return (() => {
              const n = Specular$dInternal$dIncremental.constant($2);
              Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
              return n;
            })();
          })())(sectionParametersD);
          return (() => {
            Specular$dInternal$dIncremental$dNode.annotate($2, "itemParameters");
            return $2;
          })();
        })());
        return (() => {
          Specular$dInternal$dIncremental$dNode.annotate($2, "menuItemVariants");
          return $2;
        })();
      })())(v1 => {
        if (v1.length === 0) { return Restaumatic$dPrelude$dSpecular.wempty; }
        if (v1.length === 1) {
          const $2 = v1[0];
          return Specular$dDom$dElement.el("button")([
            Specular$dDom$dElement.attr("type")("button"),
            Specular$dDom$dElement.classes(["btn", "add-button"]),
            $2.isAvailable && $1.availability.tag === "Available"
              ? Specular$dDom$dElement.onClick_(openProductCreator($2.productKey()))
              : Specular$dDom$dElement.attr("disabled")("disabled")
          ])(Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.shoppingCartIcon(true))(() => Specular$dInternal$dRIO.bindImpl((() => {
            if ($2.label.tag === "Just") {
              return Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x => x)(Specular$dDom$dElement.text($2.label._1)))(Specular$dDom$dElement.text(" – "));
            }
            if ($2.label.tag === "Nothing") { return Specular$dInternal$dRIO.pureImpl(); }
            $runtime.fail();
          })())(() => Specular$dInternal$dRIO.bindImpl((() => {
            if ($2.price.tag === "Just") {
              return Specular$dDom$dElement.text((() => {
                if ($2.price._1.tag === "Constant") { return Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())($2.price._1._1.value); }
                if ($2.price._1.tag === "Range") {
                  return Restaumatic$dI18n._translate(
                    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.menu.price_from),
                    {}
                  ) + " " + Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())($2.price._1._1.from);
                }
                $runtime.fail();
              })());
            }
            if ($2.price.tag === "Nothing") { return Specular$dInternal$dRIO.pureImpl(); }
            $runtime.fail();
          })())(() => Specular$dInternal$dRIO.bindImpl(Specular$dExtra.nbsp)(() => {
            if ($2.params.tag === "Just") {
              return Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.itemCountBadge(cartProductCountFn(menuSectionItem._1.itemProduct)($2.params._1));
            }
            if ($2.params.tag === "Nothing") { return Specular$dInternal$dRIO.pureImpl(); }
            $runtime.fail();
          })))));
        }
        return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("button")([
          Specular$dDom$dElement.attr("type")("button"),
          Specular$dDom$dElement.classes(["btn", "add-button", "dropdown-toggle"]),
          Specular$dDom$dElement.attr("data-bs-toggle")("dropdown"),
          Specular$dDom$dElement.attr("data-bs-display")("static"),
          Specular$dDom$dElement.attr("aria-expanded")("false"),
          (() => {
            const $2 = $1.availability.tag === "Available";
            if (!$2) { return Specular$dDom$dElement.attr("disabled")("disabled"); }
            if ($2) { return Specular$dDom$dElement.monoidProp.mempty; }
            $runtime.fail();
          })()
        ])(Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.shoppingCartIcon(true))(() => {
          const priceRange = Data$dFoldable.foldlArray(acc => price => Data$dMaybe.$Maybe(
            "Just",
            (() => {
              if (acc.tag === "Nothing") { return price; }
              if (acc.tag === "Just") { return Restaumatic$dMenu$dV2$dPriceView.mergePriceView(price)(acc._1); }
              $runtime.fail();
            })()
          ))(Data$dMaybe.Nothing)(Data$dArray.mapMaybe(v2 => v2.price)(v1));
          return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text((() => {
            if (priceRange.tag === "Just") {
              if (priceRange._1.tag === "Constant") { return Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(priceRange._1._1.value); }
              if (priceRange._1.tag === "Range") {
                return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.menu.price_from), {}) + " " + Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(priceRange._1._1.from);
              }
              $runtime.fail();
            }
            if (priceRange.tag === "Nothing") {
              return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.menu.add_to_cart), {});
            }
            $runtime.fail();
          })()))(() => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x => x)(Specular$dExtra.nbsp))(Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.caretIcon));
        })))(() => Specular$dDom$dElement.el("ul")([Specular$dDom$dElement.class_("dropdown-menu")])(Data$dFoldable.foldrArray(x => {
          const $2 = Specular$dDom$dElement.el("li")([x.isAvailable ? Specular$dDom$dElement.monoidProp.mempty : Specular$dDom$dElement.class_("disabled")])(Specular$dDom$dElement.el("a")([
            Specular$dDom$dElement.attr("href")("#"),
            Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_(x.isAvailable ? (b => openProductCreator(x.productKey(b))) : Specular$dCallback.nullCallback)
          ])(Specular$dInternal$dRIO.bindImpl((() => {
            if (x.label.tag === "Just") { return Specular$dDom$dElement.text(x.label._1); }
            if (x.label.tag === "Nothing") { return Specular$dInternal$dRIO.pureImpl(); }
            $runtime.fail();
          })())(() => Specular$dInternal$dRIO.bindImpl((() => {
            if (x.label.tag === "Nothing") { return false; }
            if (x.label.tag === "Just") { return true; }
            $runtime.fail();
          })() && (() => {
            if (x.price.tag === "Nothing") { return false; }
            if (x.price.tag === "Just") { return true; }
            $runtime.fail();
          })()
            ? Specular$dDom$dElement.text(" – ")
            : Specular$dInternal$dRIO.pureImpl())(() => Specular$dInternal$dRIO.bindImpl((() => {
            if (x.price.tag === "Just") { return Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.displayPriceView(x.price._1); }
            if (x.price.tag === "Nothing") { return Specular$dInternal$dRIO.pureImpl(); }
            $runtime.fail();
          })())(() => Specular$dInternal$dRIO.bindImpl(Specular$dExtra.nbsp)(() => {
            if (x.params.tag === "Just") {
              return Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.itemCountBadge(cartProductCountFn(menuSectionItem._1.itemProduct)(x.params._1));
            }
            if (x.params.tag === "Nothing") { return Specular$dInternal$dRIO.pureImpl(); }
            $runtime.fail();
          }))))));
          return b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v => x$1 => x$1)($2))(b);
        })(Specular$dInternal$dRIO.pureImpl())(v1)));
      }));
    }
    if ($0.tag === "Nothing") { return Specular$dInternal$dRIO.pureImpl(); }
    $runtime.fail();
  }
  if (menuSectionItem.tag === "ProductCombo") { return Specular$dInternal$dRIO.pureImpl(); }
  if (menuSectionItem.tag === "ProductCreator") {
    const $0 = Data$dTraversable.traversableArray.traverse(Data$dMaybe.applicativeMaybe)(Restaumatic$dMenu$dV2$dMenuCatalogue.lookupProduct(catalogueMemo.catalogue))(menuSectionItem._1.creatorProducts);
    if ($0.tag === "Just") {
      return Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("btn-group")])(Specular$dDom$dElement.el("button")([
        Specular$dDom$dElement.attr("type")("button"),
        Specular$dDom$dElement.classes(["btn", "add-button"]),
        Specular$dDom$dElement.onClick_((() => {
          const $1 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dMenu$dV2$dProductKey.mkProductCreatorKey(catalogueMemo)(Data$dArray.zip(menuSectionItem._1.creatorProducts)($0._1)))(sectionParametersD));
          return () => {
            const f = $1();
            return openProductCreator(f)();
          };
        })())
      ])(Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.shoppingCartIcon(false)));
    }
    if ($0.tag === "Nothing") { return Specular$dInternal$dRIO.pureImpl(); }
    $runtime.fail();
  }
  return Restaumatic$dPrelude$dSpecular.wempty;
};
const injectWidget = node => widget => Specular$dProfiling.measure(Effect$dClass.monadEffectEffect)("MenuV2.injectWidget")((() => {
  const $0 = Specular$dDom$dBrowser.setTextImpl(node)("");
  return () => {
    $0();
    Specular$dDom$dWidget.runWidgetInNode(node)(widget)();
  };
})());
const hideElement = /* #__PURE__ */ Web$dDOM$dElement.setAttribute("style")("display: none;");
const getMenuV2Elements = () => {
  const $0 = Web$dHTML.window();
  const document = Web$dHTML$dWindow.document($0)();
  const $1 = Web$dDOM$dDocument.getElementsByClassName("menuv2-section")(document)();
  const sectionElements = Web$dDOM$dHTMLCollection.toArray($1)();
  return Data$dTraversable.traversableArray.traverse(Effect.applicativeEffect)(sectionEl => {
    const $2 = Web$dDOM$dElement.getAttribute("data-menu-section-id")(sectionEl);
    return () => {
      const dataMb = $2();
      const $3 = Web$dDOM$dElement.getElementsByClassName("menuv2-column")(sectionEl)();
      const columnEls = Web$dDOM$dHTMLCollection.toArray($3)();
      const columns = Data$dTraversable.traversableArray.traverse(Effect.applicativeEffect)(columnEl => {
        const $4 = Web$dDOM$dElement.getAttribute("data-menu-section-item-id")(columnEl);
        return () => {
          const dataMb$1 = $4();
          const dataMb$2 = Web$dDOM$dElement.getAttribute("data-parameter-id")(columnEl)();
          const dataMb$3 = Web$dDOM$dElement.getAttribute("data-choice-id")(columnEl)();
          return {
            node: columnEl,
            menuSectionItemId: Data$dMaybe$dExtra.unsafeFromJust("invalid data-menu-section-item-id")((() => {
              if (dataMb$1.tag === "Just") {
                if (Data$dUUID.isValidUUID(dataMb$1._1)) { return Data$dMaybe.$Maybe("Just", dataMb$1._1); }
                return Data$dMaybe.Nothing;
              }
              if (dataMb$1.tag === "Nothing") { return Data$dMaybe.Nothing; }
              $runtime.fail();
            })()),
            parameterId: Data$dMaybe$dExtra.unsafeFromJust("invalid data-parameter-id")((() => {
              if (dataMb$2.tag === "Just") {
                if (Data$dUUID.isValidUUID(dataMb$2._1)) { return Data$dMaybe.$Maybe("Just", dataMb$2._1); }
                return Data$dMaybe.Nothing;
              }
              if (dataMb$2.tag === "Nothing") { return Data$dMaybe.Nothing; }
              $runtime.fail();
            })()),
            choiceId: Data$dMaybe$dExtra.unsafeFromJust("invalid data-choice-id")((() => {
              if (dataMb$3.tag === "Just") {
                if (Data$dUUID.isValidUUID(dataMb$3._1)) { return Data$dMaybe.$Maybe("Just", dataMb$3._1); }
                return Data$dMaybe.Nothing;
              }
              if (dataMb$3.tag === "Nothing") { return Data$dMaybe.Nothing; }
              $runtime.fail();
            })())
          };
        };
      })(columnEls)();
      const $4 = Web$dDOM$dElement.getElementsByClassName("menuv2-cart-button")(sectionEl)();
      const buttonEls = Web$dDOM$dHTMLCollection.toArray($4)();
      const buttons = Data$dTraversable.traversableArray.traverse(Effect.applicativeEffect)(buttonEl => {
        const $5 = Web$dDOM$dElement.getAttribute("data-menu-section-item-id")(buttonEl);
        return () => {
          const dataMb$1 = $5();
          return {
            node: buttonEl,
            menuSectionItemId: Data$dMaybe$dExtra.unsafeFromJust("invalid data-menu-section-item-id")((() => {
              if (dataMb$1.tag === "Just") {
                if (Data$dUUID.isValidUUID(dataMb$1._1)) { return Data$dMaybe.$Maybe("Just", dataMb$1._1); }
                return Data$dMaybe.Nothing;
              }
              if (dataMb$1.tag === "Nothing") { return Data$dMaybe.Nothing; }
              $runtime.fail();
            })())
          };
        };
      })(buttonEls)();
      const $5 = Web$dDOM$dElement.getElementsByClassName("menuv2-availability")(sectionEl)();
      const availabilityScheduleEls = Web$dDOM$dHTMLCollection.toArray($5)();
      const availabilitySchedules = Data$dTraversable.traversableArray.traverse(Effect.applicativeEffect)(avEl => {
        const $6 = Web$dDOM$dElement.getAttribute("data-availability-schedule-id")(avEl);
        return () => {
          const dataMb$1 = $6();
          return {
            node: avEl,
            availabilityScheduleId: Data$dMaybe$dExtra.unsafeFromJust("invalid data-availability-schedule-id")((() => {
              if (dataMb$1.tag === "Just") {
                if (Data$dUUID.isValidUUID(dataMb$1._1)) { return Data$dMaybe.$Maybe("Just", dataMb$1._1); }
                return Data$dMaybe.Nothing;
              }
              if (dataMb$1.tag === "Nothing") { return Data$dMaybe.Nothing; }
              $runtime.fail();
            })())
          };
        };
      })(availabilityScheduleEls)();
      return {
        menuSectionId: Data$dMaybe$dExtra.unsafeFromJust("invalid data-menu-section-id")((() => {
          if (dataMb.tag === "Just") {
            if (Data$dUUID.isValidUUID(dataMb._1)) { return Data$dMaybe.$Maybe("Just", dataMb._1); }
            return Data$dMaybe.Nothing;
          }
          if (dataMb.tag === "Nothing") { return Data$dMaybe.Nothing; }
          $runtime.fail();
        })()),
        node: sectionEl,
        columns,
        buttons,
        availabilitySchedules
      };
    };
  })(sectionElements)();
};
const disableSectionElement = el => {
  const $0 = hideElement(el);
  return () => {
    $0();
    const $1 = Web$dDOM$dElement.classList(el)();
    return Web$dDOM$dDOMTokenList.remove($1)("js-group-item")();
  };
};
const init = v => {
  const $0 = v.cartProductCountFn;
  const $1 = v.catalogue;
  const $2 = v.locale;
  const $3 = v.menuEnv;
  const $4 = v.openProductCreator;
  const $5 = v.tz;
  const catalogueMemo = {catalogue: $1, parametersMemo: {value: Data$dMap$dInternal.Leaf}};
  return () => {
    const menuSections = getMenuV2Elements();
    const a$p = Effect$dNow.now();
    const localDateTime = Data$dTime$dLocal.utcToLocalDateTime(Data$dDateTime$dInstant.toDateTime(a$p))($5);
    const globalParameters = Data$dFoldable.foldableArray.foldMap(Specular$dFRP$dBase.monoidDynamic({
      mempty: Data$dMap$dInternal.Leaf,
      Semigroup0: () => ({append: Data$dMap$dInternal.union(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId)})
    }))(x => x)([
      (() => {
        const n = Specular$dInternal$dIncremental.constant(Data$dMap$dInternal.$$$Map(
          "Two",
          Data$dMap$dInternal.Leaf,
          Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.IsDivided,
          Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.$InternalParameterChoiceId("IsDividedChoice", false),
          Data$dMap$dInternal.Leaf
        ));
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })(),
      Specular$dFRP$dBase.functorDynamic.map(v1 => v1.params)($3)
    ]);
    Data$dFoldable.foldrArray(x => {
      const $6 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(x.menuSectionId)(Data$dRecord.unsafeGet("sections")($1));
      const $7 = (() => {
        if ($6.tag === "Just") {
          const $7 = $6._1;
          const $8 = Data$dRecord.unsafeGet("visibilitySchedule")($7);
          const $9 = (() => {
            if ($8.tag === "Just") { return Data$dMap$dInternal.lookup(Data$dOrd.ordString)($8._1)(Data$dRecord.unsafeGet("availabilitySchedules")($1)); }
            if ($8.tag === "Nothing") { return Data$dMaybe.Nothing; }
            $runtime.fail();
          })();
          const $10 = (() => {
            if ($9.tag === "Just") {
              if (
                Restaumatic$dCalendar$dTypes$dAvailability.eqAvailabilityStatus.eq(Restaumatic$dCalendar$dTypes$dAvailability.availabilityStatus(Data$dRecord.unsafeGet("availability")($9._1))(localDateTime))(Restaumatic$dCalendar$dTypes$dAvailability.Available)
              ) {
                const $10 = Effect$dConsole.log("Menu section " + x.menuSectionId + " available,");
                return () => {
                  $10();
                  const toggleElements = Utils$dDOM.globalQuerySelectorAll(".js-toggle-group-list-item[data-section-id=\"" + x.menuSectionId + "\"]")();
                  return Data$dFoldable.foldrArray(x$1 => {
                    const $11 = Web$dDOM$dElement.classList(x$1);
                    return b => () => {
                      const classList = $11();
                      Web$dDOM$dDOMTokenList.remove(classList)("hidden")();
                      return b();
                    };
                  })(() => {})(toggleElements)();
                };
              }
              const $10 = Effect$dConsole.log("Menu section " + x.menuSectionId + " not available, hiding");
              return () => {
                $10();
                disableSectionElement(x.node)();
                const toggleElements = Utils$dDOM.globalQuerySelectorAll(".js-toggle-group-list-item[data-section-id=\"" + x.menuSectionId + "\"]")();
                return Data$dFoldable.foldrArray(x$1 => {
                  const $11 = hideElement(x$1);
                  return b => () => {
                    $11();
                    return b();
                  };
                })(() => {})(toggleElements)();
              };
            }
            if ($9.tag === "Nothing") { return () => {}; }
            $runtime.fail();
          })();
          return () => {
            $10();
            const v2 = Specular$dRef.new(Effect$dClass.monadEffectEffect)(Data$dRecord.unsafeGet("customParameterValues")($7))();
            const sectionParametersD = Specular$dFRP$dBase.semigroupDynamic({append: Data$dMap$dInternal.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)}).append(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dMenu$dV2$dParametric.fromInternalParameterValues)(globalParameters))(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dMenu$dV2$dParametric.fromCustomParameterValues)(v2._1));
            Data$dFoldable.foldrArray(x$1 => {
              const $11 = Specular$dProfiling.measure(Effect$dClass.monadEffectEffect)("MenuV2.sectionItemColumn")(injectWidget(x$1.node)(Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.sectionItemColumn($1)($0)(sectionParametersD)(x.menuSectionId)(x$1.menuSectionItemId)(x$1.parameterId)(x$1.choiceId)));
              return b => () => {
                $11();
                return b();
              };
            })(() => {})(x.columns)();
            Data$dFoldable.foldrArray(x$1 => {
              const $11 = Specular$dProfiling.measure(Effect$dClass.monadEffectEffect)("MenuV2.sectionItemButton")(injectWidget(x$1.node)((() => {
                const $11 = Restaumatic$dMenu$dV2$dMenuCatalogue.lookupSectionItem($1)(x.menuSectionId)(x$1.menuSectionItemId);
                if ($11.tag === "Just") { return sectionItemButton($2)(sectionParametersD)(catalogueMemo)($7)($11._1)($3)($4)($0); }
                if ($11.tag === "Nothing") { return Specular$dInternal$dRIO.pureImpl(); }
                $runtime.fail();
              })()));
              return b => () => {
                $11();
                return b();
              };
            })(() => {})(x.buttons)();
            return Data$dFoldable.foldrArray(x$1 => {
              const $11 = Specular$dProfiling.measure(Effect$dClass.monadEffectEffect)("MenuV2.sectionItemAvailabilityBadge")(injectWidget(x$1.node)(Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.sectionItemAvailabilityBadge()()({
                catalogue: $1,
                localDateTime,
                availabilityScheduleId: x$1.availabilityScheduleId
              })));
              return b => () => {
                $11();
                return b();
              };
            })(() => {})(x.availabilitySchedules)();
          };
        }
        if ($6.tag === "Nothing") { return () => {}; }
        $runtime.fail();
      })();
      return b => () => {
        $7();
        return b();
      };
    })(() => {})(menuSections)();
    return initMenuToggle();
  };
};
const initStandalone = options => {
  const a$p = Effect$dNow.now();
  const tz = Data$dTime$dLocal.udecodeTZLabel.unsafeDecode(options.tz);
  const $0 = Data$dTime$dLocal.utcToLocalDateTime(Data$dDateTime$dInstant.toDateTime(a$p))(tz);
  const locale = Restaumatic$dI18n.getGlobalLocale(Effect$dClass.monadEffectEffect)();
  return init({
    catalogue: options.catalogue,
    locale,
    openProductCreator: productKey => {
      const $1 = Restaumatic$dMenu$dV2$dTypes$dCartToOrder.encodeCartProductKey.encode(productKey);
      return () => options.openProductCreator($1);
    },
    cartProductCountFn: productId => parameterValues => Specular$dFRP$dBase.functorDynamic.map(f => f(
      productId,
      Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.encodeUUID)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      }).encode(Restaumatic$dMenu$dV2$dParametric.onlyCustomParameterValues(parameterValues))
    ))(options.cartProductCountFn),
    tz,
    menuEnv: Restaumatic$dMenu$dV2$dEnv.menuEnv(options.catalogue)(locale)((() => {
      const n = Specular$dInternal$dIncremental.constant($0);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })())((() => {
      const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.Nothing);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })())((() => {
      const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.Nothing);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })())((() => {
      const $1 = Restaumatic$dMenu$dV2$dTypes$dOrderOrigin.unscrambleDecodeOrderOrigin.unsafeDecode(options.origin);
      return (() => {
        const n = Specular$dInternal$dIncremental.constant($1);
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })();
    })())
  })();
};
export {disableSectionElement, getMenuV2Elements, hideElement, init, initStandalone, injectWidget, sectionItemButton, showElement, toFulfillmentMethod};
export * from "./foreign.js";
